import React, { Component } from "react";

import { SkeletonTheme } from "react-loading-skeleton";
export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <SkeletonTheme>
        <div>{this.props.children}</div>
      </SkeletonTheme>
    );
  }
}
